import rawContent from '../data/content';

const WORKER_BASE_URL = process.env.REACT_APP_BASE_URL || 'https://sln-backend.sridhar-gkrishnamurthy.workers.dev';

class ContentWrapper {
  constructor() {
    this.content = rawContent;
  }

  async init() {
    if (typeof window === 'undefined') return this;

    try {
      // Try backend
      const json = await loadContent();
      if (json && Object.keys(json).length > 0) {
        this.content = json;

        try {
          window.localStorage.setItem('sln_content_v1', JSON.stringify(json));
        } catch {}
        return this;
      }
    } catch (err) {
      console.warn('Backend load failed:', err);
    }

    // Try localStorage
    if (window.localStorage) {
      try {
        const saved = window.localStorage.getItem('sln_content_v1');
        if (saved) {
          console.log('Loaded content from localStorage');
          this.content = JSON.parse(saved);
        }
      } catch {}
    }

    return this;
  }

  resolveImage(src) {
    if (!src || typeof src !== 'string') return '';
    if (src.startsWith('data:')) return src;
    console.log(`Resolving image path for: /images/${src}`);
    return `/images/${src}`;
  }

  getCompany() {
    const company = { ...this.content.company };
    company.logo = this.resolveImage(company.logo);
    return company;
  }

  getHeroSlides() {
    return (this.content.hero || []).map(slide => ({
      ...slide,
      image: this.resolveImage(slide.image)
    }));
  }

  getServices() {
    return (this.content.services || []).map(service => ({
      ...service,
      image: this.resolveImage(service.image)
    }));
  }

  getTeam() {
    return (this.content.team || []).map(member => ({
      ...member,
      photo: this.resolveImage(member.photo)
    }));
  }

  getPortfolio() {
    return (this.content.portfolio || []).map(item => ({
      ...item,
      image: this.resolveImage(item.image)
    }));
  }
}

// Export a singleton Promise that callers can `await`
const contentWrapperPromise = new ContentWrapper().init();
export default contentWrapperPromise;

// Backend API
export async function loadContent() {
  const response = await fetch(`${WORKER_BASE_URL}/data`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    throw new Error(`Failed to load content: ${response.statusText}`);
  }
  return await response.json();
}

export async function saveContent(data) {
  const response = await fetch(`${WORKER_BASE_URL}/data`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Failed to save content');
  return await response.text();
}
